import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Timeline from "../pages/timeline/page";
import Archive from "../pages/archive/page";
import ArchiveDetail from "../pages/archive-detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/timeline",
    element: <Timeline />,
  },
  {
    path: "/archive",
    element: <Archive />,
  },
  {
    path: "/archive/:id",
    element: <ArchiveDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;